import { IOnlinePublicationMessages } from '../../types';

export const PUBLICATIONS_NAME = 'Publication Name';
export const Reports = 'Reports';
export const STATUS = 'Status';
export const AUTHOR = 'Created By';
export const UPDATE_TIME = 'Last Updated';
export const DELETE = 'Delete';
export const DELETE_CELL_WIDTH = 64;
export const PUBLICATIONS_ROW_HEIGHT = 80;
export const CELL_STYLE = { display: 'flex', alignItems: 'center', border: 'none', background: 'transparent' };
export const CELL_DELETE_STYLE = {
  display: 'flex',
  flex: 1,
  alignItems: 'center',
  justifyContent: 'center',
  border: 'none',
  background: 'transparent'
};

export const MAX_LOGO_FILE_SIZE = 200 * 1000; // 200kB
export const LOGO_REQUIREMENTS: IOnlinePublicationMessages['logoRequirements']['arguments'] = {
  dimensions: '250px * 150px',
  fileSize: '200 KB',
  fileTypes: '.jpeg, .jpg, .png, .bmp'
};

export const DEFAULT_COLOR_BAR_LENGTH = 7;
export const PUBLICATION_TOC_MAX_HEADER_FILE_SIZE = 5 * 1000 * 1000; // 5 MB

export const MAX_MEDIA_LINKS_COUNT = 3;
export const ITEMS_PER_PAGE_OPTION = [
  { label: '20', value: 20 },
  { label: '40', value: 40 },
  { label: '60', value: 60 }
];
export const DATE_FORMAT = 'MMMM Do YYYY, h:mm A';
export const BTN_SIZE_LARGE = 'large';
export const BTN_VAR_PRIMARY = 'primary';
export const CAPTION_COPY_OF = 'Copy of ';
